import axios from "axios";

const onFulfilled = (response: any) => {
  return response;
}

const onRejected = (error: any) => {
  if (error.response.status === 401) {
    delete dcCertificateAPI.defaults.headers.common["Authorization"];
    localStorage.removeItem('token')
  }

  return Promise.reject(error);
}

export const dcCertificateAPI = axios.create({
  baseURL: process.env.REACT_APP_DC_CERTIFICATE_HOST,
});

if (localStorage.getItem("token")) dcCertificateAPI.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");

dcCertificateAPI.defaults.headers.common["x-apikey"] = process.env.REACT_APP_APIKEY;

dcCertificateAPI.interceptors.response.use(onFulfilled, onRejected);

export default dcCertificateAPI